export const shop_per_page: number = 8;
